import { useMutation } from "@tanstack/react-query";
import { niceDecrypt } from "src/api/decryptNice";
const useDecryptNiceInfo = ()=>{
    return useMutation({
        mutationFn: (param)=>{
            let { tokenVersionId , encData  } = param;
            return niceDecrypt({
                tokenVersionId,
                encData
            });
        }
    });
};
export default useDecryptNiceInfo;
